if (!customElements.get('airgo-product')) {
  customElements.define('airgo-product', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const on = (el, type, cb) => el?.addEventListener(type, cb, {signal});
      const main = this.querySelector('[data-main-image]');
      const zoom = this.querySelector('[data-zoom-image]');
      const dialog = this.querySelector('[data-lightbox]');
      const imageButton = this.querySelector('[data-zoom]');
      const video = this.querySelector('[data-gallery-video]');
      const thumbnails = Array.from(this.querySelectorAll('.ag-thumbnail'));
      const thumbnailRail = this.querySelector('.ag-thumbnails');
      let galleryIndex = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      const pauseVideo = () => {
        video?.pause();
        if (video?.readyState > 0) video.currentTime = 0;
      };
      on(document, 'visibilitychange', () => { if (document.hidden) video?.pause(); });
      const revealThumbnail = button => {
        // Scroll only the thumbnail rail, so selecting a variant cannot move the page.
        const railBounds = thumbnailRail.getBoundingClientRect();
        const buttonBounds = button.getBoundingClientRect();
        const offsetX = buttonBounds.left < railBounds.left ? buttonBounds.left - railBounds.left : Math.max(0, buttonBounds.right - railBounds.right);
        const offsetY = buttonBounds.top < railBounds.top ? buttonBounds.top - railBounds.top : Math.max(0, buttonBounds.bottom - railBounds.bottom);
        thumbnailRail.scrollBy({left: offsetX, top: offsetY, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      const selectMedia = (index, reveal = true) => {
        galleryIndex = (index + thumbnails.length) % thumbnails.length;
        const selected = thumbnails[galleryIndex];
        const isVideo = selected.dataset.mediaType === 'video';
        pauseVideo();
        imageButton.hidden = isVideo;
        video.hidden = !isVideo;
        if (isVideo) {
          // The viewer starts playback using the native controls; never autoplay.
          if (video.readyState === 0) video.load();
        } else {
          main.src = selected.dataset.image; main.alt = selected.dataset.alt;
          zoom.src = selected.dataset.image; zoom.alt = selected.dataset.alt;
          imageButton.setAttribute('aria-label', 'Enlarge ' + selected.dataset.alt.toLowerCase());
        }
        this.querySelector('[data-image-caption]').textContent = selected.dataset.alt;
        this.querySelector('[data-gallery-caption-note]').textContent = isVideo ? 'Product demonstration · 0:21' : 'Designed to make room.';
        this.querySelector('[data-gallery-caption-note]').hidden = !isVideo;
        this.querySelector('[data-caption-zoom]').hidden = isVideo;
        this.querySelector('[data-gallery-counter]').textContent = `${galleryIndex + 1} / ${thumbnails.length}`;
        thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
        if (reveal) revealThumbnail(selected);
      };
      const setImage = src => {
        const index = thumbnails.findIndex(button => button.dataset.image === src);
        if (index !== -1) selectMedia(index);
      };
      this.galleryFrame = requestAnimationFrame(() => revealThumbnail(thumbnails[galleryIndex]));
      thumbnails.forEach((button, index) => {
        on(button, 'click', () => selectMedia(index));
        on(button, 'keydown', event => {
          let nextIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = thumbnails.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          selectMedia(nextIndex);
          thumbnails[galleryIndex].focus({preventScroll: true});
        });
      });
      on(this.querySelector('[data-gallery-previous]'), 'click', () => selectMedia(galleryIndex - 1));
      on(this.querySelector('[data-gallery-next]'), 'click', () => selectMedia(galleryIndex + 1));
      on(imageButton, 'click', () => dialog.showModal());
      on(this.querySelector('[data-caption-zoom]'), 'click', () => dialog.showModal());
      on(this.querySelector('[data-close-zoom]'), 'click', () => dialog.close());
      on(dialog, 'click', e => { if (e.target === dialog) dialog.close(); });
      this.querySelectorAll('input[name="id"]').forEach(r => on(r, 'change', () => {
        if (!r.checked) return;
        this.querySelectorAll('[data-selected-price],[data-button-price],[data-sticky-price]').forEach(e => e.textContent = r.dataset.price);
        this.querySelector('[data-sticky-title]').textContent = r.dataset.title;
        this.querySelector('[data-inclusions]').textContent = r.dataset.description + '.';
        this.querySelector('[data-cart-status]').textContent = '';
        const available = r.dataset.available === 'true';
        this.querySelectorAll('[data-add],[data-sticky-add]').forEach(b => b.disabled = !available);
        this.querySelectorAll('[data-add-label],[data-sticky-label]').forEach(e => e.textContent = available ? 'Add to bag' : 'Sold out');
        setImage(r.dataset.image);
        if (this.dataset.updateUrl === 'true') {
          const url = new URL(location.href); url.searchParams.set('variant', r.value); history.replaceState({}, '', url);
        }
      }));
      const qty = this.querySelector('input[name="quantity"]');
      const clamp = n => Math.min(99, Math.max(1, parseInt(n, 10) || 1));
      on(this.querySelector('[data-quantity-minus]'), 'click', () => qty.value = clamp(clamp(qty.value) - 1));
      on(this.querySelector('[data-quantity-plus]'), 'click', () => qty.value = clamp(clamp(qty.value) + 1));
      on(qty, 'change', () => qty.value = clamp(qty.value));
      const form = this.querySelector('form[action*="/cart/add"]');
      on(form, 'submit', async e => {
        e.preventDefault();
        if (this.busy) return;
        this.busy = true;
        const buttons = this.querySelectorAll('[data-add],[data-sticky-add]');
        const status = this.querySelector('[data-cart-status]');
        const label = this.querySelector('[data-add-label]');
        buttons.forEach(b => b.disabled = true); label.textContent = 'Adding…'; status.textContent = '';
        try {
          const response = await fetch(form.action + '.js', {method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'This item could not be added. Please try again.');
          const shopRoot = window.Shopify?.routes?.root || '/';
          window.location.assign(shopRoot + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Please try again.';
          label.textContent = 'Add to bag'; buttons.forEach(b => b.disabled = false); this.busy = false;
        }
      });
      const sticky = this.querySelector('[data-sticky-buy]');
      this.observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }, {threshold: 0});
      if (form) this.observer.observe(form);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.galleryFrame);
      const video = this.querySelector('[data-gallery-video]');
      video?.pause();
      if (video?.readyState > 0) video.currentTime = 0;
      this.abortController?.abort(); this.observer?.disconnect(); this.bound = false;
    }
  });
}
document.addEventListener('click', e => {
  const link = e.target.closest('.ag-mobile-menu a');
  if (link) link.closest('details').open = false;
});
